/**
 * The common routes component is used for routes that don&#x27;t belong to a specific workstream such as the homepage, faq&#x27;s, or marketing pages that need to be defined.
 *
 * @module views/Navigation/Routes
 */
import React from 'react';
import {
  Route,
  Routes,
  useParams
} from 'react-router-dom';

import { useApolloClient } from '@apollo/client';

import ContentContainer from '@ulta/core/containers/ContentContainer/ContentContainer';
import RouteContainer from '@ulta/core/containers/RouteContainer/RouteContainer';
import VisualizationProvider from '@ulta/core/providers/VisualizationProvider/VisualizationProvider';
import CMS_QUERY from '@ulta/core/utils/graphql/queries/cms/cms';
import CMS_PREVIEW_QUERY from '@ulta/core/utils/graphql/queries/cms/preview';

import MicroformAppWrapper from '../MicroformAppWrapper/MicroformAppWrapper';

/**
 * Represents a Routes component
 *
 * @method
 * @param { Object } props - React properties passed from composition
 * @returns Routes
 */
export const ApplicationRoutes = function( props ){
  // TODO: OLD v5 way const { isNative, location } = props;
  const { isNative, href, searchParams, pathname } = props;
  const apolloClient = useApolloClient();

  const params = useParams();

  return (
    <Routes>
      <Route
        path='/cms/preview'
        element={
          <VisualizationProvider
            params={ params }
          >
            <RouteContainer
              params={ params }
              href={ href }
              pathname={ pathname }
              searchParams={ searchParams }
              DXL_QUERY={ CMS_PREVIEW_QUERY }
              fetchPolicy={ 'cache-first' }
              isNative={ isNative }
            />
          </VisualizationProvider>
        }
      />
      <Route
        path='/checkout/microform/full'
        element={ <MicroformAppWrapper isCvvOnly={ false } /> }
      />
      <Route
        path='/checkout/microform/compact'
        element={ <MicroformAppWrapper isCvvOnly={ true } /> }
      />
      <Route
        path='/*'
        element={
          <ContentContainer>
            <RouteContainer
              params={ params }
              href={ href }
              pathname={ pathname }
              searchParams={ searchParams }
              DXL_QUERY={ CMS_QUERY }
              /*
                this fetch policy is very senstive for staging and prod usage. on server we need to be cache-first
                to build the apollo state, however one that is complete can respect on the client the other configurations
              */
              fetchPolicy={ 'cache-first' }
              isNative={ isNative }
            />
          </ContentContainer>
        }
      />
    </Routes>
  );
};

export default ApplicationRoutes;
